import apiClient from "@/libs/apiClient"
import { API_URLS } from "./apiUrls"

export function apiGetWidgetConfig(requestData) {
  // export function apiGetWidgetConfig() {
  const endpoint = API_URLS.getWidgetConfigUrl()

  return apiClient.post(endpoint, requestData, { useCache: true })

  // return Promise.resolve({
  //   resultInfo: {
  //     transactionID: "c334e92a-78dd-4285-b470-7392d68335b8",
  //     statusCode: "200",
  //     message: "OK",
  //     status: "SUCCESS",
  //   },
  //   data: [
  //     {
  //       clientId: "jiomart",
  //       type: "vertical_config",
  //       subtype: "layout",
  //       data: {
  //         selectedLayout: "layout_two",
  //         reviewImage: {
  //           required: true,
  //           hidden: false,
  //         },
  //         filters: {
  //           rating: {
  //             required: true,
  //             hidden: false,
  //           },
  //           sortBy: {
  //             required: true,
  //             hidden: false,
  //           },
  //           variantsFilter: {
  //             required: true,
  //             hidden: false,
  //           },
  //           imageFilter: {
  //             required: true,
  //             hidden: false,
  //           },
  //         },
  //         title: {
  //           required: true,
  //           hidden: false,
  //         },
  //         location: {
  //           required: true,
  //           hidden: false,
  //         },
  //         reortAbuse: {
  //           required: true,
  //           hidden: true,
  //         },
  //         variantInfo: {
  //           required: true,
  //           hidden: true,
  //         },
  //         upvote: {
  //           required: true,
  //           hidden: false,
  //         },
  //         downvote: {
  //           required: true,
  //           hidden: true,
  //         },
  //         showGallery: {
  //           required: true,
  //           hidden: false,
  //         },
  //       },
  //     },
  //     {
  //       clientId: "jiomart",
  //       type: "vertical_config",
  //       subtype: "review_properties",
  //       data: {
  //         title: {
  //           required: false,
  //           hidden: false,
  //           minCharLimit: 5,
  //           maxCharLimit: 50,
  //         },
  //         content: {
  //           required: false,
  //           hidden: false,
  //           minCharLimit: 0,
  //           maxCharLimit: 140,
  //         },
  //         suggestedReview: {
  //           required: false,
  //           hidden: false,
  //           minCharLimit: 0,
  //           maxCharLimit: 140,
  //         },
  //         rating: {
  //           required: true,
  //           hidden: false,
  //           step: 1,
  //           min: 1,
  //           max: 5,
  //         },
  //         image: {
  //           required: false,
  //           hidden: false,
  //           countLimit: 3,
  //           sizeLimitInMegaBytes: 2,
  //         },
  //         upvote: {
  //           required: false,
  //           hidden: false,
  //         },
  //         downvote: {
  //           required: false,
  //           hidden: true,
  //         },
  //         abuseReport: {
  //           required: false,
  //           hidden: true,
  //           abusiveWords: ["FUCK", "SHIT", "IMPOSSIBLE"],
  //           reportReasonList: [
  //             {
  //               reasonType: '"Inappropriate Language"',
  //               reasonDescription: '"offensive disrespectful/obscene content"',
  //             },
  //             {
  //               reasonType: '"Off Topic"',
  //               reasonDescription: '"Comment is not about the product"',
  //             },
  //             {
  //               reasonType: '"Misinformation"',
  //               reasonDescription: '"Comment provides inaccurate information"',
  //             },
  //             {
  //               reasonType: '"Spam/Fake"',
  //               reasonDescription:
  //                 '"comment appears to be inauthentic/paid for"',
  //             },
  //           ],
  //         },
  //         customerPosting: {
  //           required: false,
  //           hidden: true,
  //           maxCount: 150,
  //         },
  //         customerEditing: {
  //           required: true,
  //           hidden: false,
  //           maxCount: 3,
  //         },
  //         verifyReview: {
  //           required: false,
  //           hidden: false,
  //         },
  //         setVerifyTag: {
  //           required: true,
  //           hidden: false,
  //         },
  //         customerMultipleReviewByProductPosting: {
  //           required: false,
  //           hidden: false,
  //         },
  //         sendSEOAttributes: {
  //           required: false,
  //           hidden: false,
  //         },
  //         populateVariantDetail: {
  //           required: false,
  //           hidden: false,
  //         },
  //       },
  //     },
  //   ],
  // })
}
